import { useQuery } from "@tanstack/react-query"

import { api } from "@/api"
import { ENDPOINTS } from "@/constants"
import { useAuth } from "@/contexts/auth"
import type { DashboardPaymentTypeEnum } from "@/enums"
import { DateHelper } from "@/helpers"
import type {
  DashboardPaymentType,
  DashboardSearchParamsType,
} from "@/types/dashboard"
import { StringHelper } from "@/utils"

export const getDashboardPayment = async (
  params: DashboardSearchParamsType<DashboardPaymentTypeEnum>
) => {
  const queryString =
    StringHelper.objectToQueryString(params)
  const url = `${ENDPOINTS.DASHBOARD_PAYMENT}?${queryString}`
  const { data } = await api.get<DashboardPaymentType>(url)
  return data
}

export const useDashboardPayment = ({
  startDate,
  endDate,
  dashboardType,
  enabled = true,
}: DashboardSearchParamsType<DashboardPaymentTypeEnum> & {
  enabled?: boolean
}) => {
  const { selectedWhiteLabel, authData } = useAuth()
  const isAuthenticated = !!authData?.accessToken
  const { from, to } = DateHelper.getFromAndToDateMonth({
    from: startDate,
    to: endDate,
  })
  const queryStringParams: DashboardSearchParamsType<DashboardPaymentTypeEnum> =
    {
      startDate: from,
      endDate: to,
      dashboardType,
      whitelabel_ids: selectedWhiteLabel?.uuid,
    }
  return useQuery({
    queryKey: ["dashboard-payment", queryStringParams],
    queryFn: async () => {
      return await getDashboardPayment(queryStringParams)
    },
    staleTime: 10 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    enabled: enabled && isAuthenticated,
  })
}
export default useDashboardPayment
